<template>
  <div class="avatar-settings">
    <ul class="default-avatars-list"
        :class="listClasses">
      <li v-for="(key, index) in defaultAvatars"
          class="avatar-background"
          :key="index"
          @click="changeDefaultAvatar(index)">
          <div :style="getDefaultAvatar(index)"
                class="default-avatar"></div>
      </li>

      <div class="load-image-icon">
        <input type="file"
               accept="image/*"
               name="file"
               id="file"
               ref="file"
               class="inputfile"
               @change="onAvatarUpload" />
        <label for="file"
               class="file-label">
          <icon-photo width="30"
                      height="30"
                      iconColor="#7c65b5"
                      :disabled="uploading" />
        </label>
      </div>
    </ul>
  </div>
</template>

<script>
  import { compressImage }  from '@/services/avatar.js'
  import { changeDefaultAvatar } from '@/services/avatar.js'
  import analytics from '@/services/analytics.js'

  export default {
    props: {
      child: {
        type: Object,
        required: true
      },

      defaultAvatars: {
        type: Object,
        required: true
      },

      uploading: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        avatars: {}
      }
    },

    created() {
      this.avatars = this.defaultAvatars
      delete this.avatars['deleted_user']
    },

    computed: {
      listClasses() {
        return {
          'default-avatars-list-disabled': this.uploading
        }
      }
    },

    methods: {
      getDefaultAvatar(key) {
        let image = this.defaultAvatars[key]

        return {
          'background-image': 'url(' + image + ')',
          'background-size': 'cover',
          'background-position': 'center'
        }
      },

      onAvatarUpload() {
        if (!this.uploading && this.$refs.file.files.length) {
          compressImage(this.$refs.file.files[0], result => {
            analytics.sendEvent('Pk_Camera_EditCh')
            this.$emit('uploadingAvatar', result)
            this.$refs.file.value = ''
          })
        }
      },

      changeDefaultAvatar(avatar_id) {
        let { id, group_id } = this.child

        analytics.sendEvent('Pk_Avatar_EditCh')

        changeDefaultAvatar(group_id, id, avatar_id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avatar-settings {
    padding-bottom: 20px;
    border-bottom: 1px solid #f2f2f2;

    .default-avatars-list {
      width: 300px;
      list-style: none;

      padding: 0;
      margin: 0 auto;

      display: flex;
      justify-content: space-between;

      &-disabled {
        pointer-events: none;
      }

      .avatar-background {
        width: 34px;
        height: 34px;
        background: #f1f0f9;
        border-radius: 50%;
        cursor: pointer;

        .default-avatar {
          width: 34px;
          height: 34px;
        }
      }

      .load-image-icon {
        width: 34px;
        height: 34px;

        display: flex;
        justify-content: center;
        align-items: center;

        background: #f1f0f9;
        border-radius: 50%;

        .file-label {
          cursor: pointer;
        }

        .inputfile {
          width: 0.1px;
          height: 0.1px;
          opacity: 0;
          overflow: hidden;
          position: absolute;
          z-index: -1;
        }
      }
    }
  }
</style>
